var link_preview_default = {
  "fontElementMap": "y0NPp",
  "linkPreviewContainer": "vby1T",
  "linkPreview": "k3iTz",
  "linkPreviewImage": "dlLUU",
  "linkPreviewPlaceholder": "_9lbEv",
  "linkPreviewInfo": "_7lneJ",
  "linkPreviewTitle": "XTUl-",
  "linkPreviewDescription": "CjCs6",
  "linkPreviewUrl": "P-F1E",
  "linkPreviewResponsiveImage": "hzJlR",
  "loadingContainer": "ALtbf",
  "errorIcon": "DTwT-",
  "errorInfo": "zhOAo",
  "errorContainer": "_7WwL6",
  "overlay": "dbe-f",
  "thumbnailEnd": "_2r2SL",
  "thumbnailStart": "bEc9V",
  "thumbnailTop": "_9gnCV"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
